import * as R from "remeda";
import { Identifier, usePermissions } from "react-admin";
import { Permissions, TeamScope } from "./authProvider";

export const useGlobalPermission = (permission: string): boolean => {
	const { permissions } = usePermissions<Permissions>();

	return !!(permissions && permissions.global.includes(permission));
};

export const useOrganPermission = (permission: string) => {
	const { permissions } = usePermissions<Permissions>();

	const permissionScopes = R.pathOr(permissions, ["organ", permission], []);

	return {
		hasPermission: !!permissionScopes.length,
		hasPermissionInOrgan: (organId: Identifier): boolean => {
			return R.pipe(
				permissionScopes,
				R.find(R.equals({ organ: organId })),
				R.isDefined
			);
		},
	};
};

export const useTeamRoleAssignmentPermission = (permission: string) => {
	const { permissions } = usePermissions<Permissions>();

	const permissionScopes = permissions.team_role_assignment[permission] || [];

	return {
		hasPermissionForAnyRole: (teamId: Identifier): boolean => {
			return R.pipe(
				permissionScopes,
				R.find((scope: TeamScope) => scope.team === teamId),
				R.isDefined
			);
		},
		hasPermissionForRole: (teamId: Identifier, roleId: number): boolean => {
			return R.pipe(
				permissionScopes,
				R.find(R.equals({ team: teamId, target_role: roleId })),
				R.isDefined
			);
		},
	};
};
